import React from "react";
import { Grid, Section, Typography, Divider } from "../../core";
import { MixStyle, media, theme } from "../../styles";

import ConversionContractForm from "../../components/ConversionContractForm";
import styled from "styled-components";

const { colors } = theme;
const Container = styled.div`
  margin: 50px 0px;
`;
const TittleWraper = styled.div`
  ${MixStyle.flexCenter};
  h1 {
    ${media.minitablet`font-size:36px;`};
  }
  .d-inline--block {
    display: inline-block;
  }
`;
const AddConversionContract = () => {
  // const dispatch = useDispatch();
  // dispatch(updateCurrentPath("Add Contract", "Conversion Contract"));
  // const contract_serial_no = useSelector(
  //   (state) => state.contractReducer.contracts.length + 1
  // );
  // const company_id = Number(localStorage.getItem("company_id"));

  // const company_array = useSelector((state) => state.createCompany.company);
  // console.log(company_array);
  // const company_name_abbr =
  //   company_array.length !== 0
  //     ? Serial_No_UTILS.generate_no(company_array, company_id)
  //     : null;
  // const serial_no = company_name_abbr + "-" + contract_serial_no;

  return (
    <Container>
      <Grid>
        <Section padding="10px 50px">
          {/* <Typography
              align="right"
              color="#55BD86"
              text={serial_no}
              as="h3"
            /> */}
          <TittleWraper>
            <Typography
              className="d-inline--block"
              align="center"
              as="h1"
              color={colors.darkPink}
              weight="bold"
            >
              Conversion Contract
              <Divider />
            </Typography>
          </TittleWraper>
          <ConversionContractForm serial_no={""} />
        </Section>
      </Grid>
    </Container>
  );
};

export default AddConversionContract;
